import { Alert, Button, Col, Form, Input, Row, Typography } from "antd";
import React, { useState } from "react";
import {
  API_BASE_URL,
  CREATE_MASTER_SPECIALITY,
  directToken,
} from "../services/end_points";
import { _post } from "../services/service_api";

const AddSpeciality = ({ updateUserList }) => {
  const [alert, setAlert] = useState();
  const [formdata, setFormdata] = useState({ masterSpeciality: "" });
  const [success, setSuccess] = useState(false);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormdata((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleReset = () => {
    setFormdata({ masterSpeciality: "" });
  };

  const handleSpeciality = async (e) => {
    e.preventDefault();
    try {
      const response = await _post(
        `${API_BASE_URL}${CREATE_MASTER_SPECIALITY}`,
        formdata,
        directToken
      );
      updateUserList(response.data);
      if (response.status === 201) {
        setAlert(true);
        setSuccess(true); // Optionally, set success state
        handleReset(); // Reset the form after successful submission
      }
    } catch (err) {
      console.error(err);
      setAlert(false);
      setSuccess(false);
    }
  };

  return (
    <>
      <Row>
        <Form onFinish={handleSpeciality} layout="vertical">
          <div>
            <div>
              {alert && (
                <div>
                  <Alert
                    type="success"
                    style={{
                      backgroundColor: "#dff0d8",
                      color: "green",
                      fontSize: "16px",
                      borderColor: "#dff0d8",
                      textAlign: "center",
                    }}
                    message={"City Created!"}
                  />
                </div>
              )}
            </div>

            <>
              <Col
                md={20}
                xl={24}
                lg={24}
                sm={24}
                style={{
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Form.Item label="Add Speciality Name" required>
                  <Input
                    id="specialitiesName"
                    name="masterSpeciality"
                    value={formdata.masterSpeciality}
                    onChange={handleFormChange}
                    style={{ width: "100%" }}
                  />
                </Form.Item>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: "1rem", // Adjust spacing as needed
                    width: "20vw",
                  }}
                >
                  <Button
                    type="button"
                    onClick={handleReset}
                    style={{
                      color: "black",
                      border: "solid blue",
                      width: "6vw",
                      borderRadius: "1vw",
                    }}
                  >
                    Reset
                  </Button>
                  <Button
                    type="submit"
                    onClick={handleSpeciality}
                    style={{
                      color: "white",
                      background: "#1677ff",
                      width: "6vw",
                      borderRadius: "1vw",
                    }}
                  >
                    Submit
                  </Button>
                </div>
              </Col>
            </>
          </div>
        </Form>
      </Row>
    </>
  );
};

export default AddSpeciality;
